module.exports = __webpack_public_path__ + "static/media/Lateral_Moderate_Z2.c6b45832.png";